
        import * as module0 from './controllers/dropdown_controller.js';import * as module1 from './controllers/example_controller.js';import * as module2 from './controllers/gallery_controller.js';import * as module3 from './controllers/image_gallery_controller.js';import * as module4 from './controllers/toggle_controller.js'
        const modules = {
            "./controllers/dropdown_controller.js": module0,
            "./controllers/example_controller.js": module1,
            "./controllers/gallery_controller.js": module2,
            "./controllers/image_gallery_controller.js": module3,
            "./controllers/toggle_controller.js": module4,
        };
        export default modules;
      